import { Component } from '@angular/core';
import { DividendComponent } from './dividend.component';

@Component({
  selector: 'eid-dividend-mobile',
  templateUrl: './dividend.mobile.component.html',
  styleUrls: ['./dividend.mobile.component.scss']
})
export class DividendMobileComponent extends DividendComponent {}
